import { createFileRoute } from '@tanstack/react-router'
import { AerospaceGVIPage } from 'pages/aerospaceGVI/AerospaceGVIPage'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'

export const Route = createFileRoute('/aerospace-gvi/')({
  component: AerospaceGVIRouteComponent,
  staticData: {
    title: 'Aerospace GVI',
  },
})

function AerospaceGVIRouteComponent() {
  const params = Route.useSearch()

  return (
    <AerospaceGVIPage
      orgId={params[SEARCH_PARAM_ORG_ID]}
      siteId={params[SEARCH_PARAM_SITE_ID]}
    />
  )
}
